(function () {
	"use strict";

	// Wait for DOM to be ready
	document.addEventListener("DOMContentLoaded", function () {
		const listingsBlock = document.querySelector(".wp-block-listings");
		const fallbackLogo = listingsBlock.getAttribute("data-fallback-logo") || "";
		if (!listingsBlock) return;

		// Get elements
		const searchInput = document.getElementById("listings-search-input");
		const categorySelect = document.getElementById("listings-category-filter");
		const subcategoryWrapper = document.querySelector(".listings-subcategory");
		const subcategorySelect = document.getElementById(
			"listings-subcategory-filter",
		);
		const townSelect = document.getElementById("listings-town-filter");
		const listingsGrid = document.querySelector(".listings-grid");
		const loadingIndicator = document.querySelector(
			".wp-block-listings-loading",
		);
		const resultsCount = document.querySelector(".wp-block-listings-count");
		const currentCountSpan = document.querySelector(".listings-count-current");
		const totalCountSpan = document.querySelector(".listings-count-total");
		const paginationContainer = document.querySelector(
			".wp-block-listings-pagination",
		);
		const resetButton = document.getElementById("listings-reset-button");

		// Get API URL and subcategories data
		const apiUrl = listingsBlock.getAttribute("data-api-url");
		const subcategoriesData = JSON.parse(
			document.getElementById("listings-subcategories-data").textContent,
		);

		// Contact icons
		const emailIcon =
			'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"/></svg>';
		const smsIcon =
			'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64L80 64l0 320 224 0 0-320z"/></svg>';
		const callIcon =
			'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"/></svg>';

		// Initialize filters from URL parameters
		function getFiltersFromURL() {
			const params = new URLSearchParams(window.location.search);
			return {
				search: params.get("search") || "",
				category: params.get("category") || "",
				subcategory: params.get("subcategory") || "",
				town: params.get("town") || "",
				page: parseInt(params.get("page")) || 1,
				per_page: 24,
			};
		}

		// Current filter state
		let currentFilters = getFiltersFromURL();

		// Debounce function for search input
		function debounce(func, delay) {
			let timeoutId;
			return function (...args) {
				clearTimeout(timeoutId);
				timeoutId = setTimeout(() => func.apply(this, args), delay);
			};
		}

		// Show loading state
		function showLoading() {
			if (loadingIndicator) loadingIndicator.style.display = "flex";
			if (listingsGrid) listingsGrid.style.opacity = "0.5";
		}

		// Hide loading state
		function hideLoading() {
			if (loadingIndicator) loadingIndicator.style.display = "none";
			if (listingsGrid) listingsGrid.style.opacity = "1";
		}

		// Check if any filters are active and enable/disable reset button
		function updateResetButtonVisibility() {
			const hasActiveFilters =
				currentFilters.search ||
				currentFilters.category ||
				currentFilters.subcategory ||
				currentFilters.town;
			if (resetButton) {
				resetButton.disabled = !hasActiveFilters;
			}
		}

		// Reset all filters
		function resetFilters() {
			// Clear all filter values
			currentFilters.search = "";
			currentFilters.category = "";
			currentFilters.subcategory = "";
			currentFilters.town = "";
			currentFilters.page = 1;

			// Reset UI elements
			if (searchInput) searchInput.value = "";
			if (categorySelect) categorySelect.value = "";
			if (subcategorySelect) subcategorySelect.value = "";
			if (townSelect) townSelect.value = "";

			// Hide subcategory dropdown
			if (subcategoryWrapper) subcategoryWrapper.style.display = "none";

			// Hide reset button
			updateResetButtonVisibility();

			// Fetch listings with cleared filters
			fetchListings();
		}

		// Build query string from filters
		function buildQueryString() {
			const params = new URLSearchParams();
			if (currentFilters.search) params.append("search", currentFilters.search);
			if (currentFilters.category)
				params.append("category", currentFilters.category);
			if (currentFilters.subcategory)
				params.append("subcategory", currentFilters.subcategory);
			if (currentFilters.town) params.append("town", currentFilters.town);
			params.append("page", currentFilters.page);
			params.append("per_page", currentFilters.per_page);
			return params.toString();
		}

		// Generate star rating HTML
		function generateStars(averageScore) {
			const fullStar =
				'<svg viewBox="0 0 20 20" class="frmsvg"><path fill="#FDB022" d="m10 .5 2.64 6.36 6.87.55-5.23 4.48 1.6 6.7L10 15l-5.88 3.59 1.6-6.7L.49 7.41l6.86-.55L10 .5Z"></path></svg>';
			const halfStar =
				'<svg viewBox="0 0 20 20" class="frmsvg"><g clip-path="url(#frm-star-half-clip-path)"><path fill="#F2F4F7" d="m10 .5 2.64 6.36 6.87.55-5.23 4.48 1.6 6.7L10 15l-5.88 3.59 1.6-6.7L.49 7.41l6.86-.55L10 .5Z"></path><path fill="#FDB022" d="M4.12 18.59 10 15V.5L7.36 6.86.49 7.4l5.23 4.48-1.6 6.7Z"></path></g><defs><clipPath id="frm-star-half-clip-path"><path fill="#fff" d="M0 0h20v20H0z"></path></clipPath></defs></svg>';
			const emptyStar =
				'<svg viewBox="0 0 20 20" class="frmsvg"><g clip-path="url(#frm-star-clip-path)"><path fill="#EAECF0" d="m10 .5 2.64 6.36 6.87.55-5.23 4.48 1.6 6.7L10 15l-5.88 3.59 1.6-6.7L.49 7.41l6.86-.55L10 .5Z"></path></g><defs><clipPath id="frm-star-clip-path"><path fill="#fff" d="M0 0h20v20H0z"></path></clipPath></defs></svg>';

			const fullStars = Math.floor(averageScore);
			const halfStars = averageScore - fullStars >= 0.5 ? 1 : 0;
			const emptyStars = 5 - (fullStars + halfStars);

			return (
				fullStar.repeat(fullStars) +
				halfStar.repeat(halfStars) +
				emptyStar.repeat(emptyStars)
			);
		}

		// Escape HTML to prevent XSS
		function escapeHtml(text) {
			if (!text) return "";
			const div = document.createElement("div");
			div.textContent = text;
			return div.innerHTML;
		}

		// Decode text to input correct symbols
		function decodeHtmlEntities(text) {
			if (!text) return "";
			const textarea = document.createElement("textarea");
			textarea.innerHTML = text;
			return textarea.value;
}

		// Fetch listings from API
		async function fetchListings(scrollToTop = false) {
			showLoading();

			try {
				const queryString = buildQueryString();
				const response = await fetch(`${apiUrl}?${queryString}`);

				if (!response.ok) {
					throw new Error("Failed to fetch listings");
				}

				const data = await response.json();

				if (data.success) {
					updateListingsGrid(data.listings, scrollToTop);
					updateResultsCount(data.pagination);
					updatePagination(data.pagination);
				} else {
					throw new Error("API returned an error");
				}
			} catch (error) {
				console.error("Error fetching listings:", error);
				showError("Failed to load listings. Please try again.");
			} finally {
				hideLoading();
			}
		}

		function updateListingsGrid(listings, scrollToTop = false) {
			if (!listingsGrid) return;

			if (listings.length === 0) {
				listingsGrid.innerHTML =
					'<div class="listings-no-results"><p>No listings found.</p></div>';
				return;
			}

			let html = "";

			listings.forEach((listing) => {
				// Reviews text
				let reviewsText = "";
				if (listing.review_count > 1) {
					reviewsText = `${listing.review_count} reviews / ${listing.average_score.toFixed(
						1,
					)}`;
				} else if (listing.review_count === 1) {
					reviewsText = `1 review / ${listing.average_score.toFixed(1)}`;
				} else {
					reviewsText = "0 reviews";
				}

				const starsHtml = generateStars(listing.average_score || 0);

				// Meta = category + reviews + address (matches render.php structure)
				let metaHtml = '<div class="feature-listing-meta">';

				if (listing.category) {
					metaHtml += `<span class="feature-listing-category">${escapeHtml(
						listing.category,
					)}</span>`;
				}

				metaHtml += `
				<div class="feature-listing-reviews-header">
					<div class="feature-listing-reviews-start">
					<span>${reviewsText}</span>
					</div>
					<div class="feature-listing-reviews-end">
					${starsHtml}
					</div>
				</div>
				`;

				if (listing.full_address) {
					metaHtml += `<span class="feature-listing-address">${escapeHtml(
						listing.full_address,
					)}</span>`;
				}

				metaHtml += "</div>";

				// Subcategories: "Listed in: A, B, C"
				let subcategoriesHtml = "";
				if (listing.subcategories && listing.subcategories.length) {
					subcategoriesHtml = `
					<div class="feature-listing-subcategories">
					<strong>Listed in:</strong>
					${escapeHtml(listing.subcategories.join(", "))}
					</div>
				`;
				}

				// Contact buttons
				const emailBtn = listing.email
					? `<a href="mailto:${escapeHtml(listing.email)}">${emailIcon}<span>Email</span></a>`
					: "";
				const smsBtn = listing.mobile
					? `<a href="sms:${escapeHtml(listing.mobile)}">${smsIcon}<span>SMS</span></a>`
					: "";
				const callBtn = listing.landline
					? `<a href="tel:${escapeHtml(listing.landline)}">${callIcon}<span>Call</span></a>`
					: "";

				// Contact info text
				const landlineInfo = listing.landline
					? `<p>Landline: <a href="tel:${escapeHtml(listing.landline)}">${escapeHtml(
							listing.landline,
						)}</a></p>`
					: "";
				const mobileInfo = listing.mobile
					? `<p>Mobile: <a href="tel:${escapeHtml(listing.mobile)}">${escapeHtml(
							listing.mobile,
						)}</a></p>`
					: "";

				// Logo with fallback
				const logoSrc = listing.logo_url || fallbackLogo;
				const logoHtml = logoSrc
					? `<img src="${escapeHtml(logoSrc)}" alt="${escapeHtml(
							listing.title,
						)}">`
					: "";

				// Tier badge (Featured / Super Featured only)
				let tierBadge = "";
				if (listing.price_range === "7.5") {
					tierBadge =
						'<span class="listing-tier-badge listing-tier-featured">Featured</span>';
				} else if (listing.price_range === "15") {
					tierBadge =
						'<span class="listing-tier-badge listing-tier-super-featured">Super Featured</span>';
				}

				html += `
				<div class="feature-listing">
					<div class="feature-listing-inner">
					<div class="feature-listing-details">
						<div class="feature-listing-logo">
						${logoHtml}
						</div>
						<div class="feature-listing-info">
						<h3><a href="${escapeHtml(listing.permalink)}">${listing.title}</a></h3>
						${tierBadge}
						${metaHtml}
						${subcategoriesHtml}
						<p>${escapeHtml(decodeHtmlEntities(listing.excerpt || ""))}</p>
						</div>
					</div>
					</div>
					<div class="feature-listing-contact">
					<div class="feature-listing-contact-start">
						${landlineInfo}
						${mobileInfo}
					</div>
					<div class="feature-listing-contact-end">
						${emailBtn}
						${smsBtn}
						${callBtn}
					</div>
					</div>
				</div>
				`;
			});

			listingsGrid.innerHTML = html;

			if (scrollToTop) {
				setTimeout(() => {
					listingsBlock.scrollIntoView({ behavior: "smooth", block: "start" });
				}, 100);
			}
		}

		// Update results count
		function updateResultsCount(pagination) {
			if (!resultsCount) return;

			const showing =
				pagination.current_page * pagination.per_page > pagination.total_posts
					? pagination.total_posts
					: Math.min(
							pagination.current_page * pagination.per_page,
							pagination.total_posts,
						);

			if (currentCountSpan) currentCountSpan.textContent = showing;
			if (totalCountSpan) totalCountSpan.textContent = pagination.total_posts;
		}

		// Update pagination controls
		function updatePagination(pagination) {
			if (!paginationContainer) return;

			const { current_page, total_pages } = pagination;

			// Hide pagination if only one page
			if (total_pages <= 1) {
				paginationContainer.style.display = "none";
				return;
			}

			paginationContainer.style.display = "flex";

			// Build pagination HTML
			let html = `
				<button class="pagination-prev" data-page="${current_page - 1}" ${current_page === 1 ? "disabled" : ""}>Previous</button>
				<div class="pagination-numbers">
			`;

			// Show page numbers
			const maxButtons = 10;
			let startPage = Math.max(1, current_page - Math.floor(maxButtons / 2));
			let endPage = Math.min(total_pages, startPage + maxButtons - 1);

			if (endPage - startPage < maxButtons - 1) {
				startPage = Math.max(1, endPage - maxButtons + 1);
			}

			for (let i = startPage; i <= endPage; i++) {
				const activeClass = i === current_page ? "active" : "";
				html += `<button class="pagination-number ${activeClass}" data-page="${i}">${i}</button>`;
			}

			if (endPage < total_pages) {
				html += '<span class="pagination-ellipsis">...</span>';
			}

			html += `
				</div>
				<button class="pagination-next" data-page="${current_page + 1}" ${current_page === total_pages ? "disabled" : ""}>Next</button>
			`;

			paginationContainer.innerHTML = html;

			// Add event listeners to pagination buttons
			paginationContainer.querySelectorAll("button").forEach((button) => {
				button.addEventListener("click", function () {
					if (this.disabled) return;
					const page = parseInt(this.getAttribute("data-page"), 10);
					currentFilters.page = page;
					fetchListings(true); // Scroll to top when paginating
				});
			});
		}

		// Show error message
		function showError(message) {
			if (listingsGrid) {
				listingsGrid.innerHTML = `<div class="listings-error"><p>${escapeHtml(message)}</p></div>`;
			}
		}

		// Update subcategory dropdown based on selected category
		function updateSubcategoryDropdown(category) {
			if (
				!category ||
				!subcategoriesData[category] ||
				subcategoriesData[category].length === 0
			) {
				subcategoryWrapper.style.display = "none";
				subcategorySelect.value = "";
				currentFilters.subcategory = "";
				return;
			}

			// Populate subcategory options
			const subcategories = subcategoriesData[category];
			let options = '<option value="">All Subcategories</option>';
			subcategories.forEach((subcat) => {
				options += `<option value="${escapeHtml(subcat)}">${escapeHtml(subcat)}</option>`;
			});

			subcategorySelect.innerHTML = options;
			subcategoryWrapper.style.display = "flex";
		}

		// Handle search input
		const handleSearch = debounce(function () {
			currentFilters.search = searchInput.value.trim();
			currentFilters.page = 1; // Reset to first page
			updateResetButtonVisibility();
			fetchListings();
		}, 500);

		// Handle category change
		function handleCategoryChange() {
			currentFilters.category = categorySelect.value;
			currentFilters.subcategory = "";
			currentFilters.page = 1;
			updateSubcategoryDropdown(currentFilters.category);
			updateResetButtonVisibility();
			fetchListings();
		}

		// Handle subcategory change
		function handleSubcategoryChange() {
			currentFilters.subcategory = subcategorySelect.value;
			currentFilters.page = 1;
			updateResetButtonVisibility();
			fetchListings();
		}

		// Handle town change
		function handleTownChange() {
			currentFilters.town = townSelect.value;
			currentFilters.page = 1;
			updateResetButtonVisibility();
			fetchListings();
		}

		// Initialize form values from URL parameters
		if (currentFilters.search && searchInput) {
			searchInput.value = currentFilters.search;
		}
		if (currentFilters.category && categorySelect) {
			categorySelect.value = currentFilters.category;
			updateSubcategoryDropdown(currentFilters.category);
		}
		if (currentFilters.subcategory && subcategorySelect) {
			subcategorySelect.value = currentFilters.subcategory;
		}
		if (currentFilters.town && townSelect) {
			townSelect.value = currentFilters.town;
		}

		// Initialize reset button state
		if (resetButton) {
			resetButton.disabled = true;
		}

		// Update reset button visibility based on initial filters
		updateResetButtonVisibility();

		// Initialize event listeners
		if (searchInput) {
			searchInput.addEventListener("input", handleSearch);
		}

		if (categorySelect) {
			categorySelect.addEventListener("change", handleCategoryChange);
		}

		if (subcategorySelect) {
			subcategorySelect.addEventListener("change", handleSubcategoryChange);
		}

		if (townSelect) {
			townSelect.addEventListener("change", handleTownChange);
		}

		if (resetButton) {
			resetButton.addEventListener("click", resetFilters);
		}

		// Fetch initial listings if filters are present from URL
		if (
			currentFilters.search ||
			currentFilters.category ||
			currentFilters.subcategory ||
			currentFilters.town
		) {
			fetchListings();
		}

		// Initialize pagination event listeners (for initial load)
		if (paginationContainer) {
			paginationContainer.querySelectorAll("button").forEach((button) => {
				button.addEventListener("click", function () {
					if (this.disabled) return;
					const page = parseInt(this.getAttribute("data-page"), 10);
					currentFilters.page = page;
					fetchListings(true); // Scroll to top when paginating
				});
			});
		}
	});
})();
